<template>
  <Page class="page">
    <h1>Impresszum</h1>
    <p>Készítették: Viola Anikó és Viola Péter 2014. január 18-án, nagyjából egy éjszaka alatt. Minden jog fenntartva. Főleg ha pénzt keresünk vele.</p>
    <p>Az oldal készítői elhatárolódnak az alkohol okozta társadalmi problémákkal kapcsolatos felelősségtől, és ha érdekeik megkívánják, akkor saját maguktól is, csak az alkoholtól nem, mert azt szeretik. Mértékkel persze.</p>
  </Page>
</template>
<script>
  import Page from '../components/Page';
  export default {
    components: {Page},
  };
</script>
